/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	store: {
		name: 'BZfgL-LSE-Store'
	},
	i18next: {
		ns: ['common','error','button'],
		lngs: ['de-at']
	},
	cache: {
		reuseCachedHtml: false,
		grantCacheByETag: true
	},
	statusControllerActionHandling: true,
	debug: {
		fallbackConsole: false
	},
	useIDSelector: true
};